export default __webpack_public_path__ + "static/media/hero.9114722b.png";